"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Keys = exports.WebOSKeyTranslater = exports.DefaultKeyTranslater = exports["default"] = void 0;

var _events = require("events");

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var KeyController =
/*#__PURE__*/
function (_EventEmitter) {
  _inherits(KeyController, _EventEmitter);

  function KeyController(mainElement, keyTranslater) {
    var _this;

    _classCallCheck(this, KeyController);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(KeyController).call(this));

    _defineProperty(_assertThisInitialized(_this), "keyDown", function (e) {
      //console.log(`Down: ${e.keyCode}`);
      var keyEventData = {
        keyCode: e.keyCode,
        key: _this.keyTranslater(e.keyCode),
        captured: false
      };
      var currentTarget = _this.currentlyFocused;

      while (currentTarget != null && !keyEventData.captured) {
        currentTarget.keyDown(keyEventData);
        currentTarget = currentTarget.parent;
      }

      ;

      _this.emit('keydown', keyEventData);
    });

    _this.keyTranslater = keyTranslater != null ? keyTranslater : DefaultKeyTranslater;
    _this.mainElement = mainElement;
    _this.currentlyFocused = mainElement;
    document.body.addEventListener('keydown', _this.keyDown);
    KeyController.instance = _assertThisInitialized(_this);
    window.keyController = _assertThisInitialized(_this);
    return _this;
  }

  _createClass(KeyController, [{
    key: "currentlyFocused",
    set: function set(value) {
      if (this.currentlyFocused != null) {
        this.currentlyFocused.focused = false;
      }

      this._currentlyFocused = value;

      if (value != null) {
        value.focused = true;
      }
    },
    get: function get() {
      return this._currentlyFocused;
    }
  }]);

  return KeyController;
}(_events.EventEmitter);

exports["default"] = KeyController;

var DefaultKeyTranslater = function DefaultKeyTranslater(keyCode) {
  switch (keyCode) {
    case 37:
      return Keys.LEFT;

    case 38:
      return Keys.UP;

    case 39:
      return Keys.RIGHT;

    case 40:
      return Keys.DOWN;

    case 13:
      return Keys.ENTER;

    case 65:
      return Keys.JUMPBACK;

    case 90:
      return Keys.PAUSE;

    case 69:
      return Keys.PLAY;

    case 82:
      return Keys.JUMPFORWARD;

    case 84:
      return Keys.REWIND;

    case 89:
      return Keys.FF;
  }
};

exports.DefaultKeyTranslater = DefaultKeyTranslater;

var WebOSKeyTranslater = function WebOSKeyTranslater(keyCode) {
  switch (keyCode) {
    case 37:
      return Keys.LEFT;

    case 38:
      return Keys.UP;

    case 39:
      return Keys.RIGHT;

    case 40:
      return Keys.DOWN;

    case 13:
      return Keys.ENTER;

    case 403:
      return Keys.JUMPBACK;

    case 19:
      return Keys.PAUSE;

    case 415:
      return Keys.PLAY;

    case 404:
      return Keys.JUMPFORWARD;

    case 412:
      return Keys.REWIND;

    case 417:
      return Keys.FF;
  }
};

exports.WebOSKeyTranslater = WebOSKeyTranslater;
var Keys = {
  LEFT: 0,
  UP: 1,
  RIGHT: 2,
  DOWN: 3,
  ENTER: 4,
  PLAY: 5,
  PAUSE: 6,
  PLAYPAUSE: 7,
  STOP: 8,
  REWIND: 9,
  FF: 10,
  JUMPBACK: 11,
  JUMPFORWARD: 12
}; //window.KeyController = KeyController;

exports.Keys = Keys;